// common border-radius values
export const ShRadius = {
  s: 2,
  m: 3,
  half: '50%',
} as const;

export type ShRadius = keyof typeof ShRadius;
